export default __webpack_public_path__ + "static/media/twitter.b825e3c8.svg";